export default __webpack_public_path__ + "static/media/logo-text3.08b05e9f.svg";